/**
 * templates/index.js --- Entry point for all URL subpaths
 *
 * This file generates templates of archive pages for past
 * issues of the archive. The query below uses the URL slug
 * to query the appropriate archive data.
 */

import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

/**
 * ql_templateQuery: GraphQL query for all URL paths
 * based on the slug. e.g. "archive-03/about-wet-ink"
 * will query the article "about-wet-ink" from archive
 * isssue No. 3
 */
export const ql_templateQuery = graphql`
  query($slug: String!) {
    # Test slug to differentiate between issues
    contentfulIssue(slug: { eq: $slug }) {
      title
      slug
      editorialTitle
      color
      date(formatString: "MMMM Do, YYYY")
      articles {
        title
        slug
        author
        color
        navImage {
          file {
            url
          }
        }
      }
      dropcap
      editorial {
        json
      }
      signature {
        json
      }
    }

    # Test slug to differentiate between articles
    contentfulArticle(slug: { eq: $slug }) {
      title
      subtitle {
        json
      }
      slug
      author
      date(formatString: "MMMM Do, YYYY")
      color
      dropcap
      article {
        json
      }
      bio {
        json
      }
      headshot {
        file {
          url
        }
      }

      # Inline fragments for grabbing article media
      articleMedia {
        ... on ContentfulMediaBoardThumbnail {
          thumbnailMetadata
          popUpMetadata
          mediaType
          mediaUrl
          gifUrl
          gifStill {
            file {
              url
            }
          }
          videoDescription {
            json
          }
        }
        ... on ContentfulMediaBoardBandcamp {
          title
          url
        }
        ... on ContentfulMediaBoardSoundCloud {
          title
          url
        }
        ... on ContentfulMediaBoardImage {
          title
          url
          image {
            title
            file {
              url
            }
          }
        }
      }
    }
    # Issue titles for past issue menu in header.js
    allContentfulIssue {
      edges {
        node {
          title
          slug
        }
      }
    }
  }
`

/**
 * Index (default): Checks whether the graphQL data contains
 * an issue or an article and acts as an entry point to the
 * Layout component, where it then gets parsed into its corresponding
 * Editorial/Article components.
 */
const Index = props => {
  if (props.data.contentfulIssue) {
    return (
      <>
        <SEO title={`${props.data.contentfulIssue.title} | Wet Ink Archive`} />
        <Layout
          issue={props.data.contentfulIssue}
          archiveMenuData={props.data.allContentfulIssue}
        />
      </>
    )
  } else if (props.data.contentfulArticle) {
    return (
      <>
        <SEO
          title={`${props.data.contentfulArticle.title} | Wet Ink Archive`}
        />
        <Layout
          article={props.data.contentfulArticle}
          archiveMenuData={props.data.allContentfulIssue}
        />
      </>
    )
  }
}

export default Index
